import { StateObject } from '~src/domains/common/types/common';

const reacceptFormSelector = (state: StateObject) => state.reacceptForm;

export { reacceptFormSelector };
